import { HistoryEventParametersLexi } from '@api/types';

export class LocalizationStore {
  private items: Map<string, string> = new Map();

  get(value: string, parameters?: HistoryEventParametersLexi): string {
    const lexiKey = this.items.get(value);
    if (lexiKey) {
      return t(lexiKey, parameters);
    } else {
      return value;
    }
  }

  register = (value: string, lexiKey: string) => {
    this.items.set(value, lexiKey);
  };
}
